<template>
  <div class="">
    <!-- <transition name="slide" mode="out-in"> -->
    <loading pic="loading" v-if="loadingState" key="1" />

    <div v-else class="client__wrapper" key="2">
      <div class="clients__manipulate">
        <div class="clients__actions">
          <button
            type="submit"
            @click="newPayment()"
            class="action_btn client__add"
          >
            <svg
              version="1.1"
              id="Layer_1"
              x="0px"
              y="0px"
              fill="var(--purple)"
              width="50px"
              height="50px"
              viewBox="0 0 1718.107 1659.385"
              enable-background="new 0 0 1718.107 1659.385"
              xml:space="preserve"
            >
              <g>
                <path
                  d="M1678.085,1404.443c-2.942-1.281-6.436-1.743-8.503-4.458c-7.395-9.709-19.912-15.579-28.978-23.396
                  c-6.481-5.588-3.711-4.664-24.96-19.847c-4.349-2.845-6.314-12.022-14.582-8.566c-1.909,1.509-2.901,3.866-4.741,5.437
                  c-15.227,0.075-80.589-33.218-116.006-54.574c-58.888-35.509-27.97-16.459-59.962-32.318
                  c-112.914-64.49-113.05-64.136-210.18-82.383c-15.367-2.887-31.103-3.375-46.305-7.741c-9.567-2.747-17.817-8.159-26.741-12.345
                  c-93.146-43.687-32.857-12.772-190.492-138.408c-1-0.996-19.368-15.461-27.393-25.07c-3.26-3.825-7.553-6.65-10.571-10.681
                  c-0.972-1.75-0.469-3.942-1.309-5.706c-1.771-1.688-4.307-2.04-6.326-3.266c-3.322-2.984-3.956-7.76-6.788-11.116
                  c-4.285-4.907-15.206-16.106-15.23-23.458c0.392-17.954-20.182-64.773-53.042-95.685c-13.693-13.898-47.767-32.83-52.063-34.773
                  c-0.186-2.433-2.212-3.618-3.673-5.217c-9.227-20.226-18.118-6.888-22.782-5.706c-2.157,0.531-3.273-1.675-4.321-3.115
                  c-5.902-9.563-29.751-22.935-31.183-23.968c-1.888-1.854-3.067-4.266-4.576-6.402c-2.439-3.907-6.106-6.843-8.421-10.833
                  c-3.184-5.672-8.504-9.772-14.203-12.708c-22.135-10.699-20.964-2.095-27.524-13.838c-1.316-2.302-1.447-5.003-1.461-7.587
                  c0.014-3.411-1.826-6.409-2.66-9.627c-3.556-12.032-4.056-8.861-8.566-14.203c-0.806-1.937-0.455-4.197-1.433-6.085
                  c-2.136-3.983-7.112-5.547-8.814-9.834c-2.329-5.52-2.295-11.75-4.907-17.18c-1.564-3.384-0.338-7.277-1.757-10.695
                  c-1.806-4.665-3.308-9.441-5.141-14.093c-1.454-3.501-1.047-7.525-2.929-10.861c-1.606-3.253-1.544-6.981-2.122-10.482
                  c-0.165-1.001-9.567-35.106-9.338-39.576c0.138-4.424-1.861-8.469-2.901-12.673c-3.074-19.491-5.86-51.532-11.198-75.032
                  c-0.184-1-9.33-33.249-6.712-39.687c1.792,0.868,3.673,2.116,5.754,1.392c-0.276-1.295,0.007-2.853-0.992-3.873
                  c-1.647-1.894-10.927-8.77-5.534-13.252c2.157-2.095,2.667-5.168,3.294-7.98c0.655-2.874-1.316-5.403-2.667-7.746
                  c-3.303-5.771-11.736-2.21-10.399-22.734c-4.996-20.164-11.149-19.904-12.935-28.557c-0.462-1.682-0.4-3.604-1.482-5.044
                  c-3.411-2.536-8.07-3.032-10.992-6.285c-10.938-12.276-10.341-9.435-6.547-15.023c2.384-2.736,2.364-7.16,5.651-9.138
                  c8.034-1.286,15.513,2.879,13.893-6.878c-0.799-4.293-4.3-7.181-6.278-10.861c-2.467-5.947-4.279-12.163-7.098-17.959
                  c-0.903-5.279-0.269-10.84,1.923-15.753c2.033-5.162-2.109-10.137-1.103-15.333c0.841-6.078-0.551-12.335,1.02-18.331
                  c3.571-15.213-2.092-16.848-0.586-31.748c1.027-1.702,2.798-2.825,3.763-4.569c0.448-2.35,0.055-4.762,0.289-7.126
                  c0.083-1.812,0.717-3.57,0.62-5.389c-0.641-3.432-3.563-6.147-3.453-9.772c0.075-2.27-2.762-18.781-2.756-19.992
                  c-0.518-13.783-9.639-3.133-11.281-21.866c-0.454-4.443-6.915-9.566-3.046-18.813c1.089-2.639,1.654-5.437,1.978-8.263
                  c0.2-2.529,2.929-4.603,1.799-7.257c-11.772-32.631-5.209-29.104-23.141-55.936c-1.723-2.46-0.055-5.43-0.131-8.111
                  c-1.192-2.316-3.273-3.997-5.024-5.871c-9.695-9.465-4.075-4.898-26.828-13.479c-2.247-0.717-4.624-0.303-6.919-0.634
                  c-2.57-1.02-4.507-3.177-7.098-4.162c-2.564,0.648-4.851,2.06-7.346,2.922c-1.302-0.951-2.598-1.923-4.011-2.688
                  c-2.659-1.593-13.935-1.525-16.374,0.372c-11.984,8.468-10.643,10.153-16.057,19.24c-1.552,2.425-9.943,3.686-14.975,2.612
                  c-1.268-0.662-2.302-1.654-3.432-2.495c-1.974-1.518-15.29-7.79-16.291-8.132c-3.246-0.62-6.643-0.207-9.62,1.234
                  c-5.773,2.793-14.491,1.698-20.813,2.612c-13.919,2.012-25.497,8.444-38.768,12.232c-15.783,4.504-28.727,13.302-40.511,24.454
                  c-34.873,33-34.438,34.661-33.04,78.928c1.51,8.477,1.382,19.612,2.015,22.596c1.065,5.019,4.562,4.983,6.213,8.849
                  c1.93,4.424,2.019,9.337,2.598,14.058c-0.062,7.939,2.195,8.047-5.926,24.416c-2.243,4.497,0.543,3.313-8.89,19.44
                  c-2.863,4.369,1.239,12.358,5.623,13.858c4.748,1.661,9.896,0.434,14.761,1.295c1.572,0.278,2.604,3.446,3.14,4.648
                  c0.816,1.829,3.213,5.19,3.195,7.166c-0.021,2.268-7.17,6.338,2.556,11.846c-4.422,16.985,5.496,12.627,6.221,19.969
                  c0.52,11.275-9.499,36.19,29.226,27.703c3.962-0.999,8.104-0.021,12.08-0.937c32.053-6.535,28.843-0.564,54.84,40.762
                  c8.406,18.507,14.991,22.863,11.384,29.708c-11.785,25.252-15.061,64.112-15.237,65.129c-6.798,18.707-16.647,53.5-22.231,89.069
                  c-11.113,33.379-9.009,26.295-6.802,59.402c0.158,2.536,1.502,4.776,2.35,7.125c1.482,3.266-0.641,6.609-1.426,9.772
                  c-24.131,89.205-15.365,68.133-37.929,105.429c-3.373,5.363-19.29,60.297-23.361,77.898c-1.783,7.04,0.391,11.129-13.004,39.363
                  c-2.198,4.273-3.818,8.869-6.457,12.9c-2.957,1.35-14.615,1.619-17.042,2.226c-2.005,0.496-2.75,2.612-3.811,4.142
                  c-10.924-1.807-19.684-12.06-32.52-3.687c-8.493-1.559-9.402,1.838-12.639,4.328c-3.942,1.462-13.141,0.509-13.7,13.948
                  c0.034,1.792-2.24,1.937-3.466,2.639c-4.858,1.502-9.269,4.224-12.962,7.698c-2.309,2.102-2.088,5.561-3.611,8.097
                  c-9.29,8.715-5.211,5.611-6.953,12.342c-6.13,5.87-4.424,6.008-3.68,17.518c0.186,3.211,3.163,5.086,4.541,7.746
                  c0.129,2.423-12.487,10.28-18.353,16.548c-27.174,29.032-20.582,54.52-20.451,68.139c5.87,69.198,2.77,25.74,25.746,141.326
                  c0.71,3.57,0.158,7.374,1.647,10.778c4.638,10.578,5.43,22.279,8.711,33.271c6.822,36.972,34.971,116.182,39.549,143.104
                  c4.101,19.24-1.017,4.972,5.458,41.172c1.784,9.973,0.995,49.858,0.93,53.445c-0.938,15.303,8.585,12.991-17.841,23.244
                  c-2.701,0.903-5.63-0.158-8.359,0.655c-1,0.321-16.813,4.55-20.122,6.726c-9.3,5.924-8.036,15.707-29.274,22.038
                  c-0.152,0.448-0.441,1.344-0.593,1.799c5.274,2.073,11.633-6.909,24.367-10.041c4.918-1.054,12.306-8.3,21.094-6.76
                  c-1.33,2.385-4.348,3.025-5.706,5.389c-2.515,4.259-5.286,8.421-6.891,13.142c5.008,6.217,8.459,4.948-8.69,12.101
                  c-3.887,2.04-7.381,4.886-11.591,6.278c-3.101,1.041-6.685,0.848-9.324,3.039c-2.57,1.509-3.184,4.597-4.686,6.96
                  c-1.994,3.192-10.683,7.851-12.37,8.352c-6.044,1.702-12.349,2.047-18.593,2.061c-14.609,1.537-28.344,7.105-42.561,10.447
                  c-47.667,11.245,13.499,54.921,61.09,64.246c28.613,5.606,124.671-3.115,116.175-1.915c8.351-1.18,16.686-2.87,25.085-3.671
                  c7.401-0.706,14.772,1.036,22.162-0.161c3.618-0.586,7.262-0.093,10.855-0.539c3.651-0.453,7.17-1.558,10.795-2.091
                  c8.717-1.283,0.726,1.706,17.043-4.484c1.006-0.381,29.799-11.969,32.232-13.573c10.821-14.112,3.026-16.42,1.011-20.029
                  c-2.289-4.098-1.725-7.284-5.104-10.906c-3.825-4.1-2.984-10.475-6.719-14.644c-9.171-13.553-0.234,14.515-12.122-46.02
                  c-0.392-3.219,1.54-8.674-3.459-11.012c-4.08-0.372-6.505,5.603-10.812,3.742c-8.038-11.755-14.517-91.047-14.993-106.955
                  c-0.163-5.452,1.35-10.986,0.859-16.412c-0.475-5.244-1.584-10.044-1.537-15.47c0.069-3.073-1.613-5.83-1.702-8.869
                  c-0.179-10.833-1.275-21.618-1.936-32.423c-2.117-60.314,3.039-79.499-4.293-123.87c-9.06-43.456-4.13-44.292-17.936-79.488
                  c-9.079-23.145-4.359-27.578-13.998-34.355c0.958-1.544,1.351-3.549,2.729-4.741c2.446-0.172,4.851,0.496,7.298,0.475
                  c2.894-0.42,4.479-4.052,7.622-3.59c20.465,0.484,28.783-0.724,38.033,0.634c27.249,0.869,98.955,15.795,107.634,21.397
                  c2.846,1.985,6.402,0.813,9.579,1.53c81.97,18.76,114.137,12.06,174.927,11.674c207.526-14.653,38.614-65.889,219.369,50.878
                  c56.287,37.067,121.038,74.844,186.263,96.25c69.138,17.924,28.054,20.458,105.67,24.698c34.991,1.079,29.624-0.386,49.079,4.514
                  c14.766,2.051,44.771,10.397,57.494,15.547c0,0,15.824,2.751,40.114,10.234c13.516,4.75,105.335,29.864,106.794,30.37
                  c64.954,17.409,115.021,51.225,123.781,60.87c2.234,21.446-2.258,5.118,3.838,19.957c-2.722,1.096-5.775,0.524-8.449,1.64
                  c-1.516,1.716-1.344,4.197-1.64,6.34c-0.042,7.995-33.626,34.212-32.354,44.752c0.22,3.087-1.006,6.464,0.689,9.303
                  c1.847,3.397,3.067,7.277,2.619,11.184c2.329,1.557,3.177,4.307,3.48,6.974c-0.434,0.903-1.626,0.916-2.426,1.323
                  c-4.41,1.192-12.611,8.249-14.237,9.179c-11.433,6.309-19.983,12.51-16.293,25.167c4.195,14.387,28.304,12.979,45.801,14.513
                  c21.891,1.823,82.075-17.196,100.281-29.039c3.628-2.36,5.766-8.265,9.046-11.328c3.478-3.247,7.511-4.913,11.393-7.345
                  c5.215-3.266,9.298-8.087,14.449-11.34c5.097-3.218,10.818-5.297,15.563-9.158c2.143-1.744,4.982-2.129,7.25-3.652
                  c2.24-1.482,4.493-2.929,6.781-4.335c3.498-1.752,4.504-6.294,8.023-8.495c4.998-3.126,9.405-3.444,16.895-11.992
                  c1.544-1.763,4.117-7.571,5.99-8.58c1.265-0.682,10.88-2.798,16.947-19.71C1686.129,1423.652,1685.882,1407.838,1678.085,1404.443z
                  M323.681,907.901c-1.764,0.351-4.162-1.737-2.819-3.439c0,0,29.06-24.819,53.442-49.975c31.264-31.171,41.638-54.861,49.458-70.236
                  c1.812,2.185,2.619,4.948,3.763,7.505c2.853,6.622,6.078,13.086,9.496,19.44c3.149,5.389,7.374,10.296,9.096,16.401
                  c16.903,51.41,10.147,34.412,25.125,59.623c3.211,4.204,6.237,8.552,9.496,12.728C478.796,901.31,324.688,907.9,323.681,907.901z
                  M557.88,390.473c-1.316,0.662-2.371-0.786-3.342-1.427c-2.016-1.841-12.078-8.532-7.374-10.316
                  c0.942-0.607,9.667,3.483,11.205,7.167C559.003,387.309,559.734,389.632,557.88,390.473z M1486.53,1480.598
                  c-0.055,1.978-0.303,3.956-0.531,5.94c-4.16,2.011-6.068,2.072-7.897,10.702c-8.479,3.363-1.271,2.202-17.228,7.711
                  c-1.599-2.867-1.964-6.147-3.073-9.186c-7.761-22.664-3.323-23.744,17.083-40.383c2.24-1.812,3.659-4.948,6.871-5.161
                  c0.076,1.585,0.165,3.184,0.331,4.796c2.384,0.675,4.831,1.151,7.325,1.399C1488.9,1464.534,1486.392,1472.425,1486.53,1480.598z"
                />
              </g>
            </svg>
            <p>Novo plaćanje</p>
          </button>

          <Period
            @dates="startPeriod"
            @filter-period="filterItems"
            :isGrid="true"
          />
        </div>

        <search-bar
          :searchStr="search"
          :pageSizeNr="pageSize"
          :searchType="'traži (mjesec, godina)'"
          @changed="setPageSize"
          @typed="searchItems"
        />

        <div class="">
          <div class="days__list payment__heading">
            <span>Godina</span>
            <span>Mjesec</span>
            <span>Iznos</span>
          </div>

          <div
            v-for="payment in pageOfItems"
            :key="payment._id"
            @click="selectPayment(payment)"
            class="clients__list payment__list"
          >
            <p class="client__item">{{ payment.payment_year }}</p>
            <p class="client__item">{{ payment.payment_month }}</p>
            <p class="client__item">{{ mapPayments(payment) }}</p>
          </div>
          <div class="days__list payment__heading">
            <h4 class="total__title">UKUPNO :</h4>
            <h4 class="page__total">{{ pageTotalAmount }}</h4>
          </div>
        </div>
      </div>
    </div>
    <!-- </transition> -->

    <jw-pagination
      :items="filteredClients"
      @changePage="onChangePage"
      :initialPage="initialPage"
      :pageSize="pageSize"
      :labels="customLabels"
      :styles="customStyles"
      class="pagine"
    >
    </jw-pagination>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Loading from '@/components/utils/Loading.vue';
import { customLabels, customStyles } from '@/components/utils/pageNav.js';
import SearchBar from '@/components/utils/SearchBar.vue';
import Period from '@/components/utils/Period.vue';
import navigation from '@/mixins/navigation';
import navigationSearch from '@/mixins/navigationSearch';
import searchClients from '@/mixins/searchClients';
import dayjs from 'dayjs';
import sr from 'dayjs/locale/sr';

dayjs.locale(sr);

export default {
  name: 'Payments',

  components: {
    Loading,
    SearchBar,
    Period,
  },

  mixins: [navigation, navigationSearch, searchClients],

  data() {
    return {
      customLabels,
      customStyles,
      dateFrom: new Date().toISOString().slice(0, 10),
      dateTill: new Date().toISOString().slice(0, 10),
    };
  },

  computed: {
    ...mapGetters([
      'getAllPayments',
      'getClientsPage',
      'getClientsPageSize',
      'loadingState',
    ]),

    pageTotalAmount: function () {
      return this.filteredClients
        .map((d) => d.members.reduce((a, b) => a + b.payment_amount, 0))
        .reduce((a, b) => a + b, 0);
    },
  },

  methods: {
    ...mapActions([
      'fetchPayments',
      'fetchPayment',
      'fetchClientsPage',
      'fetchClientsPageSize',
      'paymentClear',
      'setLoadingState',
    ]),

    async newPayment() {
      this.setLoadingState(true);
      this.$router.push('/payment');
      await this.paymentClear();
    },

    async selectPayment(payment) {
      this.setLoadingState(true);
      await this.fetchPayment(payment);
      this.$router.push('/payment');
    },

    mapPayments(payment) {
      return payment.members.reduce(
        (a, { payment_amount }) => a + payment_amount,
        0
      );
    },

    async searchItems(val = '') {
      await this.initItems();
      let mu = this.getAllPayments.filter((post) => {
        return (
          post.payment_year.toString().includes(val) ||
          post.payment_month.toLowerCase().includes(val.toLowerCase())
        );
      });
      this.filteredClients = mu;
    },

    startPeriod(dateFrom, dateTill) {
      this.filterItems(dateFrom, dateTill);
    },

    filterItems(dateFrom, dateTill) {
      this.dateFrom = dateFrom;
      this.dateTill = dateTill;
      let mu = this.getAllPayments.filter(
        (year) =>
          dayjs(year.payment_date).format('YYYY-MM-DD') >=
            dayjs(dateFrom).format('YYYY-MM-DD') &&
          dayjs(year.payment_date).format('YYYY-MM-DD') <=
            dayjs(dateTill).format('YYYY-MM-DD')
      );
      this.filteredClients = mu;
    },

    async initItems() {
      if (!this.getAllPayments.length) await this.fetchPayments();
      this.filteredClients = this.getAllPayments;
      this.startPeriod(this.dateFrom, this.dateTill);
      if (this.getClientsPage !== 1) this.initialPage = this.getClientsPage;
      if (this.getClientsPageSize !== 10)
        this.pageSize = this.getClientsPageSize;
    },
  },

  async mounted() {
    await this.initItems();
    this.setLoadingState(false);
  },
};
</script>

<style>
.payment__list {
  grid-template-columns: repeat(3, 1fr) !important;
  justify-items: center;
}

.payment__heading {
  grid-template-columns: repeat(3, 1fr) !important;
}

.page__total {
  grid-area: 1 / 3 / 2 / 4;
}

.total__title {
  grid-area: 1 / 2 / 2 / 3;
}
</style>
